<div class="about-group">
  <div class="about-wrapper">
    <h1>Collection Statement</h1>
    <ol>
      <li>
        <p class="sub-heading">
          Collection Statement – For collection of personal information as part of registration process
        </p>
        <p>
          Avaana Pty Ltd ACN 610 520 600 (<b>Avaana</b>) collects your personal information for the purposes of
          registering you for our website, platform and/or app and to provide you with our services. If you do not
          provide us with your personal information you may not be able to register for our website, platform and/or app
          and we may not be able to provide you with our services.
        </p>
        <p>
          We otherwise collect, use, disclose, share, transfer, store and handle your personal information in the manner
          set out in our Privacy Policy located at
          <a href="/privacy-policy">https://qa.avaana.com.au/privacy-policy</a> and as permitted by
          law. Our Privacy Policy explains how we store and use, and how you may access and correct your personal
          information and how you can lodge a complaint regarding the handling of your personal information and how we
          will handle any complaint.
        </p>
        <p>
          [We may disclose your personal information to our partners and affiliates who assist us in providing our
          services to you and who may be located in the EU and the UK. You consent to Avaana’s disclosure of your
          personal information to these recipients.]
        </p>
        <p>
          By providing your personal information to us, you consent to the collection, use, disclosure, sharing,
          transfer, storage and handling of your personal information for the purposes set out in this collection
          statement and as described in the Privacy Policy. If you wish to contact Avaana, you may do so by emailing us
          at <a href="mailto:hello@avaana.com.au">hello&#64;vaana .com.au</a>.
        </p>
      </li>

      <li>
        <p class="sub-heading">Collection Statement - For collection of health information for referral purposes</p>
        <p>
          Avaana Pty Ltd ACN 610 520 600 (<b>Avaana</b>) collects your personal information, including your health
          information, for the purposes of referring you to our partners and affiliates that provide services of the
          type requested by you. If you do not provide us with your personal information, including your health
          information, we may not be able to refer you to your desired or requested service provider.
        </p>
        <p>
          We otherwise collect, use, disclose, share, transfer, store and handle personal information in the manner set
          out in our Privacy Policy located at
          <a href="/privacy-policy">https://qa.avaana.com.au/privacy-policy</a> and as permitted by
          law. Our Privacy Policy explains how we store and use, and how you may access and correct your personal
          information and how you can lodge a complaint regarding the handling of your personal information and how we
          will handle any complaint.
        </p>
        <p>
          [We may disclose your personal information to our partners and affiliates who assist us in providing our
          services or your requested services to you and who may be located in the EU and the UK. You consent to
          Avaana’s disclosure of your personal information to these recipients.]
        </p>
        <p>
          By providing your personal information to us, you consent to the collection, use, storage and disclosure of
          that information for the purposes set out in this collection statement and as described in the Privacy Policy.
          If you wish to contact Avaana, you may do so by emailing us at
          <a href="mailto:hello@avaana.com.au">hello&#64;avaana.com.au</a>.
        </p>
      </li>
    </ol>
  </div>
</div>
